import { writable } from "svelte/store";
const loader = writable(false);
const theRoute = writable(null);
const isEditingDeckImageSize = writable(false);
const updateLanguagePanel = writable(false);
const liveCountries = writable([]);

const setLoader = val => {
  loader.update(old => val);
};

const setLiveCountries = val => {
  liveCountries.update(old => val);
};

export {
  setLoader,
  loader,
  theRoute,
  isEditingDeckImageSize,
  updateLanguagePanel,
  liveCountries,
  setLiveCountries
};
